import { applicationStore, setHttpClientInterceptors } from '@pascal/pascal-core';

export const PostMessage = {
  Reload: 'reload',
  Logout: 'logout',
  PgGetAuthInfo: 'pgGetAuthInfo',
  PgGameLoaded: 'pgGameLoaded',
  PgLogin: 'pgLogin',
  RedirectLogin: 'redirectLogin',
  RedirectHome: 'redirectHome',
  TogglePlayMode: 'togglePlayMode',
};

export const PostMessageListenerMessages = {
  UpdateBalance: 'updateBalance',
  StopAutoSpins: 'stopAutospins',
  AuthInfoUpdate: 'authInfoUpdate',
};

class IframeService {
  sendParentMessage(message, transfer, targetOrigin = '*') {
    window.parent.postMessage(message, targetOrigin, transfer);
  }

  sendTopMessage(message, transfer, targetOrigin = '*') {
    window.top.postMessage(message, targetOrigin, transfer);
  }

  openTab(tab) {
    this.sendTopMessage({ action: 'openSlider', tab });
  }

  openDeposit() {
    this.openTab('deposit');
  }

  openLogin() {
    this.openTab('login');
  }

  reloadFrame() {
    this.sendParentMessage(PostMessage.Reload);
  }

  logout() {
    this.sendParentMessage(PostMessage.Logout);
  }

  sendLoadedState() {
    this.sendParentMessage(PostMessage.PgGameLoaded);
  }

  sendGetAuthInfo() {
    this.sendParentMessage(PostMessage.PgGetAuthInfo);
  }

  sendPgLogin() {
    this.sendParentMessage(PostMessage.PgLogin);
  }

  redirectLogin() {
    this.sendParentMessage(PostMessage.RedirectLogin);
  }

  redirectHome() {
    this.sendParentMessage(PostMessage.RedirectHome);
  }

  reloadFrameForRealMoney(gameId) {
    this.sendTopMessage({ action: PostMessage.TogglePlayMode, gameId });
  }

  redirect(type = false) {
    type ? this.redirectHome() : this.redirectLogin();
  }

  /**
   * @deprecated please use redirect
   */
  redirection(type) {
    this.redirect(type);
  }

  isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  setPostMessageListener(messageParams) {
    if (!this.isInIframe()) {
      applicationStore.setIsAuthDataReceived(true);
    } else {
      window.addEventListener('message', (message) => {
        if (message.data && message.data.name === PostMessageListenerMessages.AuthInfoUpdate) {
          const { accessToken, isAuthenticated } = message.data;
          applicationStore.setIsAuthenticated(isAuthenticated);
          applicationStore.setAccessToken(accessToken);
          applicationStore.setIsAuthDataReceived(true);
          setHttpClientInterceptors();
        }

        if (messageParams && messageParams.length) {
          messageParams.forEach(({ name, callback }) => {
            if (message.data && message.data.name === name) {
              callback(message.data);
            }
          });
        }
      });
    }
  }
}

const iframeService = new IframeService();

export { iframeService, IframeService as BaseIframeService };
